import React from 'react';
import { Link } from 'react-router-dom'
import '../styles/home.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestion } from '@fortawesome/free-solid-svg-icons';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';

const INITIAL_STATE = {
  title: '',
  count: 0,
  bgColor: 'bg-primary',
  icon: faQuestion,
  link: '/',
};

class HomeItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = { ...INITIAL_STATE };
  }

  componentDidMount() {
    this.setState({
      ...this.props
    })
  }

  render() {

    const { title, count, bgColor, icon, link } = this.state;


    return (
      <div className="col-xl-3 col-sm-6 mb-3">
        <div className={"card text-white font-weight-bold o-hidden h-100 " + bgColor}>
          <div className="card-body">
            <div className="card-body-icon">
              <FontAwesomeIcon className="" icon={icon} />
            </div>
            <div className="mr-5">{count} {title}</div>
          </div>
          <Link className="card-footer text-white clearfix small z-1" to={link}>
            <span className="float-left">Ver Detalles</span>
            <span className="float-right">
              <FontAwesomeIcon className="" icon={faChevronRight} />
            </span>
          </Link>
        </div>
      </div>

    );
  }
}

export default HomeItem;